/**
 * @file Web gallery ad widget discovery page / modal container.
 */

import { withApollo } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import WebGalleryAdWidgetDiscovery from '../../components/WebGalleryAdWidgetDiscovery';
import withModal from '../../../../components/global/modal/withModal';
import { WEB_GALLERY_AD_WIDGET_MODAL } from '../../../../constants/modals';

const WebGalleryAdWidgetDiscoveryContainer = compose(
  withRouter,
  withApollo,
)(WebGalleryAdWidgetDiscovery);

export default withModal(WebGalleryAdWidgetDiscoveryContainer, {
  className: 'join-code-modal',
  name: WEB_GALLERY_AD_WIDGET_MODAL,
  contentLabel: 'Find your photos by Join Code',
  size: 'sm',
  dismissible: false,
});
